const MaterialsCard = () => {
  const materialCards = [...document.querySelectorAll(".materials__item")];

  if (materialCards.length > 0) {
    materialCards.forEach((card) => {
      const wrapper = card.querySelector(".materials__item-list-wrapper");
      const list = wrapper ? wrapper.querySelector("ul") : null;
      const btn = card.querySelector(".text-btn");
      if (wrapper && btn) {
      
        if ((wrapper.offsetHeight < 84 && !list) || (list && list.scrollHeight === wrapper.offsetHeight)) {
          btn.style.display = "none";
          return; 
        }

        let isOpen = list.classList.contains("opened");

        btn.addEventListener("click", () => {
          if (isOpen) {
            list.classList.remove("opened");
            btn.textContent = scripts_data.show_more;
          } else {
            list.classList.add("opened");
            btn.textContent = scripts_data.hide;
          }
          isOpen = !isOpen;
        });
      }
    });
  }
};

export default MaterialsCard;